module.exports = __webpack_public_path__ + "static/media/auto-mar-torun.bc69f178.jpg";